import style from './style.module.css';
const Content = () => {
  return (
    <div>
      <h1 className={style.cute}>ANE</h1>

      <p className={style.pink}>
        Hei. Jeg heter Ane! <br />
        Fakta om meg: <br />
        Haarfarge: Blond <br />
        Navn: Ane <br />
        Favoritt farge: Lilla <br />
        Favoritt drikke: Pepsi max
      </p>
    </div>
  );
};

export default Content;
